function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.37385 16.656H7.58486C7.68807 16.656 7.77982 16.6904 7.84862 16.7592L12.8945 21.2775C13.445 21.7592 13.8807 22 14.4312 22C15.1995 22 15.7615 21.4266 15.7615 20.6697V3.38761C15.7615 2.63073 15.1995 2 14.4083 2C13.8578 2 13.4908 2.25229 12.8945 2.79128L7.84862 7.27523C7.77982 7.33257 7.68807 7.36697 7.58486 7.36697H4.37385C2.79128 7.36697 2 8.16972 2 9.84404V14.1789C2 15.8532 2.79128 16.656 4.37385 16.656ZM20.3142 16.828C20.7271 17.1032 21.2775 17.0229 21.6101 16.5642C22.4817 15.3945 22.9977 13.7087 22.9977 11.9885C22.9977 10.2569 22.4817 8.58257 21.6101 7.40138C21.2775 6.95413 20.7271 6.86239 20.3142 7.14908C19.8211 7.48165 19.7408 8.06651 20.1193 8.59404C20.7385 9.44266 21.1055 10.7156 21.1055 11.9885C21.1055 13.2729 20.7271 14.5344 20.1078 15.3945C19.7523 15.922 19.8211 16.4954 20.3142 16.828Z",
  fill: "#878793"
});

function SvgIconSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSound);
export default __webpack_public_path__ + "static/media/icon-sound.7e86bdbc.svg";
export { ForwardRef as ReactComponent };